import { initializeApp } from "firebase/app";
import {
  addDoc,
  collection,
  getFirestore,
  Timestamp,
} from "firebase/firestore";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useAuth } from "../utils/context";
import { firebaseConfig } from "../utils/firebaseConfig";
import { getFormattedDate, postRequest } from "../utils/functions";
import notificationSvc from "../utils/notificationSvc";

const BookingDetails = () => {
  const { cart, selected, setCart, setSelected } = useAuth();
  const total = cart.reduce(
    (accumulator, currentValue) => accumulator + currentValue.Price,
    0
  );
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cart.length > 0 || !state.method || !selected.slot) {
      return navigate("/services");
    }
    if (!checkAuth()) {
      return navigate("/login");
    }
  }, []);

  const checkAuth = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const amount = cart.reduce(
      (accumulator, currentValue) => accumulator + currentValue.Price,
      0
    );
    const points = cart.reduce((acc, cur) => acc + cur.PointsEarned, 0);
    if (selected.payInStore) {
      handleAddBooking(points, amount, "cash");
      return;
    }
    const response = await postRequest("/payment/create", {
      price: amount,
      paymentMethod: state.method.id,
      customerId: user.StripeCustomerID,
    });
    if (response.status === 200) {
      handleAddBooking(points, amount, "card");
    } else setLoading(false);
  };

  const handleAddBooking = async (points, amount, type) => {
    await addDoc(collection(db, "Bookings"), {
      Active: true,
      CreatedBy: user.uid,
      CustomerEmail: user.email,
      DateCreated: Timestamp.fromDate(new Date()).toDate(),
      EmployeeID: selected.employee.id ?? selected.anyEmployee.id,
      EmployeeName: selected.employee.id
        ? selected.employee.Name
        : selected.anyEmployee.Name,
      EndTime: Timestamp.fromDate(
        new Date(getFormattedDate(selected.date) + " " + selected.slot.endTime)
      ).toDate(),
      FromCustomer: true,
      FullName: selected.name,
      GiftCardValue: 0,
      LocationID: selected.location.LocationID,
      LocationImage: selected.location.LocationImage || null,
      LocationName: selected.location.LocationName,
      Notes: selected.Notes ?? "",
      PaymentStatus: selected.payInStore ? null : "PREPAID",
      PaymentType: selected.payInStore ? "CASH" : "CARD",
      Phone: selected.phoneNumber,
      PointsEarned: points,
      PointsRedeemed: 0,
      PointsRedeemedValue: 0,
      Services: cart.map((crt) => {
        return {
          ...crt,
          ServiceName: crt.Name,
          ServicePointsEarned: crt.PointsEarned,
          ServicePointsToRedeem: 0,
          ServicePrice: crt.Price,
        };
      }),
      StartDate: getFormattedDate(new Date(selected.date)),
      StartTime: Timestamp.fromDate(
        new Date(
          getFormattedDate(selected.date) + " " + selected.slot.startTime
        )
      ).toDate(),
      Status: null,
      Subtotal: amount,
      Total: amount,
      TotalSavings: 0,
      UserID: user.uid,
    })
      .then((res) => {
        setLoading(false);
        notificationSvc.success("Booking completed successfully");
        setSelected({
          date: "",
          employee: null,
          location: null,
          timeSlot: null,
          email: user?.email,
          name: user?.displayName,
          phoneNumber: user?.phoneNumber,
          slot: null,
        });
        setCart([]);
        navigate("/booking-confirmed", { state: { isCompleted: true } });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        notificationSvc.error("Failed to execute payment");
      });
  };

  return (
    <>
      <Header />
      <section className="mt-5 mb-5 pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="form_box p-5">
                <span className="login100-form-title pb-4 pt-4">
                  Confirmation Booking
                </span>
                <form
                  className="login100-form validate-form"
                  onSubmit={(e) => handleSubmit(e)}
                >
                  <div className="row">
                    {cart &&
                      cart.map((crt) => (
                        <>
                          <div className="col-md-6">
                            <div
                              className="wrap-input100 validate-input mb-3"
                              data-validate="Date is required"
                            >
                              <span className="label-input100 ">
                                <p className="mb-2 ">Service: {crt.Name} </p>
                              </span>
                              <span className="focus-input100" />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div
                              className="wrap-input100 validate-input mb-3"
                              data-validate="Date is required"
                            >
                              <span className="label-input100 ">
                                <p className="mb-2 ">
                                  Price: &#163;{crt.Price}
                                </p>
                              </span>
                              <span className="focus-input100" />
                            </div>
                          </div>
                        </>
                      ))}
                    <div className="col-md-6">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">
                            Date:
                            {moment(new Date(selected.date)).format(
                              "MM/DD/yyyy"
                            )}
                          </p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">
                            location: {selected.location?.Address1}
                          </p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">
                            Team:{" "}
                            {selected.employee?.id
                              ? selected.employee?.Name
                              : selected?.anyEmployee?.Name}
                          </p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">
                            Slot Timing: {selected?.slot?.startTime}
                          </p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">Name: {selected.name}</p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">Phone: {selected.phoneNumber}</p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className="wrap-input100 validate-input mb-3"
                        data-validate="Date is required"
                      >
                        <span className="label-input100 ">
                          <p className="mb-2 ">Note:</p>
                          <p className="mb-3">{selected.Notes}.</p>
                        </span>
                        <span className="focus-input100" />
                      </div>
                    </div>
                  </div>
                  <div className="container-login100-form-btn">
                    <div className="wrap-login100-form-btn mb-3">
                      <div className="login100-form-bgbtn" />
                      <button
                        type="button"
                        onClick={() => navigate("/booking-details")}
                        className="login100-form-btn log_sub"
                      >
                        Back
                      </button>
                    </div>
                    <div className="wrap-login100-form-btn">
                      <div className="login100-form-bgbtn" />
                      <button
                        type="submit"
                        disabled={loading}
                        className="login100-form-btn log_sub"
                      >
                        {!loading
                          ? selected.payInStore
                            ? `Confirm Booking`
                            : `Pay (${total}€)`
                          : "Processing please wait..."}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default BookingDetails;
